import React, { ReactElement } from 'react';
import DishCardStyles from './styles';
import { formatPrice } from '../../../Helpers';
import { Product } from '../../../types/Product';

interface IProps {
  dish: Product;
  onClickCard: () => void;
  hasPoints: boolean;
}

const DishCard: React.FC<IProps> = ({
  dish,
  onClickCard,
  hasPoints,
}): ReactElement => {
  const {
    name,
    description,
    pictures,
    pictureUrl,
    displayPrice,
    isPriceVariable,
    unavailable,
  } = dish;

  function handleCardClick(): void {
    if (unavailable) return;

    onClickCard();
  }

  let mainPicture;

  // eslint-disable-next-line array-callback-return
  const allPictures = pictures.map(picture => {
    if (picture.url !== null) return picture;
  });

  // eslint-disable-next-line prefer-destructuring
  if (allPictures) mainPicture = allPictures[0];

  return (
    <DishCardStyles.Card onClick={handleCardClick} unavailable={unavailable}>
      {mainPicture?.url && (
        <DishCardStyles.PhotoContainer>
          <DishCardStyles.Photo
            src={mainPicture.url}
            alt={name}
            loading="lazy"
          />
        </DishCardStyles.PhotoContainer>
      )}

      <DishCardStyles.Name>{name}</DishCardStyles.Name>

      {description && (
        <DishCardStyles.Description>{description}</DishCardStyles.Description>
      )}

      {isPriceVariable && <small>A partir de</small>}

      <DishCardStyles.Price>{formatPrice(displayPrice)}</DishCardStyles.Price>

      {unavailable && (
        <DishCardStyles.Ribbon unavailable={unavailable}>
          Indisponível
        </DishCardStyles.Ribbon>
      )}

      {hasPoints && !unavailable && (
        <DishCardStyles.Ribbon>Resgatar</DishCardStyles.Ribbon>
      )}
    </DishCardStyles.Card>
  );
};

export default DishCard;
